import React from "react";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTimes,faEye } from "@fortawesome/free-solid-svg-icons";
import axios from "axios";
import Popup from "reactjs-popup";
import "bootstrap/dist/css/bootstrap.css";
import CreatableSelect from "react-select/creatable";
import { Redirect, withRouter, Link } from "react-router-dom";
import apiUrl from "../../apiUrlConstant";
import TopHeader from "../../layout/TopHeader";
import { ChartPopup } from "../../utils/utils";
import { fileUploadPath } from "../../utils/index";
import Select from "react-select";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
var ReactS3Uploader = require("react-s3-uploader");

var today = new Date(),
  date =
    today.getDate() + "/" + today.getMonth() + 1 + "/" + today.getFullYear();

class VoucherMailConfirmationComponent extends React.Component {
  state = {
    //terminationEffectiveDate: new Date(),
    //effectiveDate: new Date(),
    messageToShow: "",
    redirect: false,
    changeLandlord: false,
    delete: false,
    additionalDetails: [],
    leaseId: this.props.leaseId,
    voucherId: this.props.voucherId,
    leaseCode: this.props.leaseCode,
    costCenter:this.props.costCenter,
    fileName: "Activation-Doc.pdf",
    date: "",
    fileAdded: {},
    activationStatus: '',
    initialValues: {
      landlordId: [],
    },
  };
  style = (feature) => {
    return {
      fillColor: "#ccc",
      weight: 1,
      opacity: 1,
      color: "#003970",
      dashArray: "2",
      fillOpacity: 0.5,
    };
  };
  constructor(props) {
    super(props);
    //this.handleTypeChange = this.handleTypeChange.bind(this);
  }

  componentDidMount() {
    var date = new Date();
    var formatedDate = `${
      date.getFullYear() + 1
    }-${date.getMonth()}-${date.getDate()}`;
    this.setState({ terminationEffectiveDate: formatedDate }, () => {
      console.log(this.state.terminationEffectiveDate);
    });
    console.log(formatedDate);
    this.setState({ activationStatus:  this.props.mailConfirmationStatus });
  }


  // onUploadError() {
  //   this.setState({
  //     messsagePopup: true,
  //     popupContent: "Something Went Wrong!",
  //   });
  //   console.log("uploading error....");
  //   // alert("Something Went Wrong");
  // }

  hidePopup() {
    this.props.setMailActivation(false);
  }

  changeLandlord = (newValue, existing) => {
    var currentMapping = this.state.currentLandlordMapping; 
    currentMapping[existing]['value'] =  newValue.value;
    currentMapping[existing]['label'] =  newValue.label;
    this.setState({ currentLandlordMapping: currentMapping  });
  };

  
  redirectAfterSave = () => {
    this.setState({ delete: false });
  };

  redirectToTerminate = () => {
    var value = this.state.values;

    this.redirectAfterSave();

    var self = this;
    if (value.termination_type == "landlord_termination") {
      console.log("in if")
      axios({
        method: "post",
        url: `${apiUrl.apiUrl.url}/lease-view/get-lease-landloard-details?leaseId=${this.state.leaseId}`,
        // url: `${apiUrl.apiUrl.url}/lease-view/get-lease-landloard-details?leaseId=${this.state.costCenter}`,
      }).then(function (response) {
        if (response.data.success) {
          self.state.initialValues.landlordId =
            response.data.additionalDetails.landlordIds;
          self.setState({
            changeLandlord: true,
            additionalDetails: response.data.additionalDetails,
            landloardSelected: response.data.additionalDetails.currentLandlord,
            currentLandlordMapping: response.data.additionalDetails.currentLandlordMapping,
          });
        }
      });
    } else {
      console.log("in else")
      this.uploader.uploadFile();
    }
  };

  onUploadStart = (file, next) => {
      console.log(file, "pre process");
      this.state.fileAdded = file;
      next(file);
  }

  onUploadFinish = (e) => {
    //${this.state.voucherId}
    let fileName =
    fileUploadPath() +
      this.state.voucherId +
      "/" +
      this.state.fileName;
    var initialValuesArr = this.state.initialValues;
    initialValuesArr["document"] = fileName;
    console.log(fileName, "fileName")
    var self = this;
    axios({
      method: "post",
      url: `${apiUrl.apiUrl.url}/voucher/mail-activation?voucherId=${this.state.voucherId}`,
      data: initialValuesArr,
    }).then(function (response) {
      console.log(response, "response");
      if (!response.data.success) {
        self.props.setpopupMessageContent("Something went wrong.");
        self.props.setpopupalertMessage(true);
      } else {
        self.hidePopup();
        self.props.setpopupMessageContent("Details Stored successfully.");
        self.props.setpopupalertMessage(true);
        //self.props.setkeyCounter(Math.round());
        self.props.ths.setState({ counter : Math.random() });
        //self.props.ths.setState({});
      }
    });
  };
  render() {
    return (
      <div>
        <Formik
          initialValues={
            {
              //"leaseRegistrationDate" : "26/05/2022"
              //effectiveDate: '02/02/2022'
            }
          }
          //enableReinitialize
          onSubmit={(values, actions) => {
            console.log(values, "valuee....");
            var self = this;
            this.state.initialValues = values;

            if(typeof values.activationStatus == "undefined" && this.state.activationStatus == '') {
                this.setState({ messageToShow: "Please select activation status", delete: true });
                return false;
            }

            this.setState({ values: values });
            this.uploader.uploadFile();

            if(typeof this.state.fileAdded.name == "undefined" ) {
                this.setState({ messageToShow: "Please select file", delete: true });
                return false;
            }

          }}
        >
          {({
            values,

            errors,

            touched,

            handleChange,

            handleBlur,

            handleSubmit,

            isSubmitting,
            resetForm,
          }) => (
            <Form autoComplete="off" className="customTabs">
              <div className="unitFormContainer amend">
                <div className="container-fluid p-0">
                  <div className="row prospectAccordion">
                    <div className="col-lg-6 offset-lg-3">
                      <div className="tableContainer prospectTable mt-0">
                        <table className="table">
                          <tbody>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Lease No
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.leaseCode}
                              </td>                             
                            </tr>
                            <tr>
                            <th
                                scope="col"
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                  borderRight: "1px solid #fff",
                                  textAlign: "center",
                                }}
                              >
                                Cost Center
                              </th>
                              <td
                                style={{
                                  backgroundColor: "#005b9b",
                                  color: "#fff",
                                }}
                              >
                                {this.state.costCenter}
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                </div>

                
                <div className="container">
                  <div className="row">
                    <div className="col-lg-12">
                      <div className="inputContainer"></div>
                    </div>
                    <div className="col-lg-12">
                      <div className="tableContainer screens">
                       

                        <table className="table tableSimple">
                          <thead>
                            <tr>
                              <th>Section</th>
                              <th>Details</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr>
                              <td>Activation Status</td>
                              <td>
                              <Field
                                    as="select"
                                    name="activationStatus"
                                    onChange={(e) => {   
                                      console.log("changes", e.target.value)            
                                        this.setState({ activationStatus: e.target.value });
                                        handleChange(e);
                                    }}
                                    value={this.state.activationStatus == 1 || this.state.activationStatus == 'yes'  ? 'yes' : 'no' }
                                    >
                                    {/* <option value="">
                                        Please Select
                                    </option>      */}
                                    <option value="yes">
                                        Yes
                                    </option>
                                    <option value="no">
                                        No
                                    </option>
                                    </Field>
                              
                              </td>
                            </tr>
                            <tr>
                              <td>Document</td>
                              <td>
                                <ReactS3Uploader
                                  signingUrl={`/site/get-s3signed-url`}
                                  signingUrlMethod="GET"
                                  accept="pdf/*"
                                  s3path={`${fileUploadPath()}${this.state.voucherId}/`}
                                  preprocess={this.onUploadStart}
                                  onSignedUrl={this.onSignedUrl}
                                  onProgress={this.onUploadProgress}
                                  onError={this.onUploadError}
                                  onFinish={this.onUploadFinish}
                                  signingUrlWithCredentials={false}
                                  uploadRequestHeaders={
                                    {
                                      //"x-amz-acl": "public-read",
                                    }
                                  }
                                  contentDisposition="attachment"
                                  scrubFilename={() => this.state.fileName}
                                  server={`${apiUrl.apiUrl.url}`}
                                  inputRef={(cmp) => (this.uploadInput = cmp)}
                                  autoUpload={false}
                                  ref={(uploader) => {
                                    console.log("uploaded click", uploader, this.state.fileName);
                                    this.uploader = uploader;
                                  }}
                                />
                              </td>
                            </tr>
                            
                          </tbody>
                        </table>
                      </div>
                    </div>

                    {(
                      <div className="col-lg-12">
                        <button variant="secondary" type="submit">
                          {/* <FontAwesomeIcon icon={faTimes} />  */}
                          Submit
                        </button>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </Form>
          )}
        </Formik>

        <Popup open={this.state.delete} position="top center">
          {(close) => (
            <div>
              {this.state.messageToShow}
              <a className="close" onClick={this.redirectAfterSave}>
                &times;
              </a>
              <div>
                <button type="button" onClick={this.redirectAfterSave}>
                  Ok
                </button>
              </div>
            </div>
          )}
        </Popup>
      </div>
    );
  }
}

export default withRouter(VoucherMailConfirmationComponent);
